import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { ArtifactListItemProps } from "@/types";
import { useScreen } from "@/hooks";
import { Typography, ListItem } from "@/components/common";
import ArtifactNameDisplay from "./ArtifactNameDisplay.vue";


/**
 * Displays the body of an artifact that can be expanded.
 */
const __default__ = {
  name: "ArtifactBodyDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {},
    displayTitle: { type: Boolean },
    displayDivider: { type: Boolean },
    defaultExpanded: { type: Boolean },
    fullWidth: { type: Boolean },
    clickable: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { smallWindow } = useScreen();

const showSummary = computed(() => !!props.artifact?.summary);
const isCode = computed(() => props.artifact.isCode);
const bodyVariant = computed(() => (isCode.value ? "code" : "expandable"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ListItem), {
    dense: "",
    clickable: props.clickable,
    divider: props.displayDivider,
    class: _normalizeClass(props.fullWidth ? 'full-width' : 'artifact-display'),
    style: _normalizeStyle(_unref(smallWindow) ? 'padding: 0px' : undefined),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    subtitle: _withCtx(() => [
      (showSummary.value)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 0,
            variant: "expandable",
            value: props.artifact.summary,
            "default-expanded": props.defaultExpanded,
            "collapse-length": props.defaultExpanded ? 0 : undefined
          }, null, 8, ["value", "default-expanded", "collapse-length"]))
        : (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            variant: bodyVariant.value,
            value: props.artifact.body,
            "default-expanded": props.defaultExpanded
          }, null, 8, ["variant", "value", "default-expanded"]))
    ]),
    default: _withCtx(() => [
      (props.displayTitle)
        ? (_openBlock(), _createBlock(ArtifactNameDisplay, {
            key: 0,
            artifact: props.artifact,
            "display-type": ""
          }, null, 8, ["artifact"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["clickable", "divider", "class", "style"]))
}
}

})